export default __webpack_public_path__ + "static/bariol_serif_regular-webfont-19e8610464ab3c8ca75c0d9ca8008283.svg";